<!--edit.vue的主体-->
<template>
    <div>
        <div class="row">
            <div class="form-group col-md-2" v-for="col in entityConfigsWithoutRichText"
                 v-bind:key="getCol(col).key">
                <label class="control-label"><span v-if="getCol(col).form.required === true" class="lbl-obg">*</span>{{
                        $t(getCol(col).label)
                    }}:</label>
                <em-form-helper is-editing
                                :name="getCol(col).key"
                                :metadata="getCol(col)"
                                :value="getKeyValue(getCol(col))"
                                :self-row="$_emCustomVuexMixin_entityStore"
                                :entity="entity"
                                @input="changeEntityAttribute(getCol(col), $event)"
                                @selectModalEntity="showModal(getCol(col))"
                                @selectMultipleModalEntity="showCheckEnableModal(getCol(col))"
                                @keypress.enter.native="handleSave"
                                @bind="changeEntityAttribute(getCol(col), $event)"/>
                <span v-show="errors.has(getCol(col).key)" class="lbl-obg">
                {{ errors.first(getCol(col).key) }}
                </span>
            </div>
        </div>
        <div v-for="col in RichTextConfigs" v-bind:key="getCol(col).key">
            <rich-text :label="$t(getCol(col).label)"
                       :value="getKeyValue(getCol(col))"
                       @input="changeEntityAttribute(getCol(col), $event)">
            </rich-text>
        </div>
        <div class="col-lg-12" v-show="!saveButtonDisable">
            <div class="float-lg-right">
                <em-button type="cancel" show-name
                           v-bind:class="'btn btn-outline-secondary mr-1'"
                           v-on:click="handleCancel"></em-button>
                <em-button type="save" show-name v-bind:class="'btn btn-primary'"
                           v-menu-permission="'edit'"
                           :busy="onSaving"
                           v-on:click="handleSave"></em-button>
            </div>
        </div>
        <em-modal-entity-selector ref="emModalEntitySelector"
                                  @entityModalSelectSelected="handleEntityModalSelectSelected"/>
    </div>
</template>


<script>
import EmFormHelper from "@/components/em/EmFormHelper";
import EmButton from "@/components/em/EmButton";
import emCommonModalMixin from "@/mixin/em/common/modal";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emUtils from "@/utils/emUtils";
import RichText from "@/components/em/editor/richText";

export default {
    name: 'em-entity-edit-form',
    mixins: [emCommonModalMixin, emCustomVuexMixin],
    components: {RichText, EmFormHelper, EmButton},
    data() {
        return {
            onSaving: false
        }
    },
    props: {
        entity: {
            type: String,
            required: true
        },
        returnPath: {type: String, default: ""},
        /**
         * 有api，就以api为准
         */
        api: {type: String},
        /**
         * 没有api，才以entityApi为准
         */
        entityApi: {type: String, default: ""},
        //禁用默认保存和取消按钮
        saveButtonDisable: {
            type: Boolean,
            default: false
        },
        //自动跳转
        autoReturnDisable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        entityConfigsWithoutRichText() {
            return this.$_emCustomVuexMixin_entityConfigs.filter(col => col.form.type !== 'rich-text')
        },
        RichTextConfigs() {
            return this.$_emCustomVuexMixin_entityConfigs.filter(col => col.form.type === 'rich-text')
        }
    },
    methods: {
        changeEntityAttribute(col, $event) {
            let key = col.key
            let newValue = $event
            // this.$store.commit(`${this.entity}/set${this.entityCapFirst}`, {key, newValue})
            this.$_emCustomVuexMixin_setEntityAttribute(key, newValue)
            //如果是entitySelect，还可以在值发生变化后，触发预先定义的action，可以是一组action
            //在entityForm组件和filter组件中都会调用下面的代码，通过最后的type参数是：entity/filter来区分是谁调用的  - 2020-6-19
            if (col.form.type === 'entitySelect') {
                let id = $event ? $event : 0
                if (col.form.onChangeDispatchAction) {
                    for (let i in col.form.onChangeDispatchAction) {
                        let onChangeDispatchActionParams = col.form.onChangeDispatchActionParams && col.form.onChangeDispatchActionParams[i] ? col.form.onChangeDispatchActionParams[i] : {}
                        this.$store.dispatch(col.form.onChangeDispatchAction[i], {
                            id, //原设计，我只能予以保留了，怕影响到原来的什么功能，虽然没搜索到这个的调用
                            key,
                            newValue,
                            mainEntity: this.entity,
                            type: 'entity',
                            onChangeDispatchActionParams
                        })
                    }
                }
            }
            //向外触发事件
            this.$emit('changeEntityAttribute', key, newValue);
        },
        getKeyValue(col) {
            if (this.$_emCustomVuexMixin_entityStore.hasOwnProperty(col.key)) {
                return this.$_emCustomVuexMixin_entityStore[col.key]
            } else {
                let localObject = this.$_emCustomVuexMixin_entityStore
                let splited = col.key.split('.')
                for (let i = 0 ; i < splited.length ; i++) {
                    if (localObject[splited[i]] === "") {
                        return localObject[splited[i]]
                    }
                    localObject = localObject[splited[i]]
                }

                return localObject
            }
        },
        getCol(col) {
            //如果type存在并且等于“variable”，并且存在dependentStateKey和forms，就返回true
            if (col.type && col.type === "variable" && col.dependentStateKey && col.forms) {
                //判断是不是moduleRoot，是就不拼装entity了，在filter中要拼装filter和Filter后缀
                let dependentState = col.dependentStateByModuleRoot ? this.$store.state[this.entity][col.dependentStateKey]
                    : this.$_emCustomVuexMixin_entityStore[col.dependentStateKey]
                if (dependentState && col.forms[dependentState]) {
                    return col.forms[dependentState]
                }
            }
            return col;
        },
        handleEntityModalSelectSelected() {
            this.$forceUpdate()
        },
        handleSave() {
            this.onSaving = true
            console.log("onSaving")
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    this.$store.dispatch('emBase/emBaseSave', {
                        entity: this.entity,
                        entityState: this.$_emCustomVuexMixin_entity,
                        api: this.api,
                        entityApi: this.entityApi,
                        returnPath: this.returnPath,
                        autoReturnDisable: this.autoReturnDisable
                    }).finally(() => {
                        console.log("handle Save finally")
                        this.onSaving = false
                    })
                }
            });
        },
        handleCancel() {
            //todo: 等emBase/backToList写完了，要切换过去
            if (!this.autoReturnDisable) {
                this.$store.dispatch('base/MMFbackToList', this.entity);
            } else {
                //深拷贝
                let _entityOrigin = JSON.parse(JSON.stringify(this.$store.state[this.entity].entityOrigin))
                //把customVuexEntity恢复到修改前的备份
                this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_entity)}`, _entityOrigin)
            }
        },
        showModal(col) {
            this.$_emCommonModalMixin_showModalSelectorByEntity({
                popCol: col,
                entityState: this.$_emCustomVuexMixin_entity,
                entity: this.entity
            })
        },
        showCheckEnableModal(col) {
            this.$_emCommonModalMixin_showMultipleSelectorByEntity({
                popCol: col,
                entityState: this.$_emCustomVuexMixin_entity,
                entity: this.entity
            })
        }
    }
}
</script>
